import {
  FROZEN_OBJECT_CURSOR,
  FROZEN_SELECTION_COLOR,
  LOCKED_OBJECT_CURSOR,
  LOCKED_SELECTION_COLOR,
  SELECTION_COLOR,
} from '@/components/app/editor/selection-chrome/selection-chrome-constants'

/**
 * Dim level for a frozen selection's decorations.
 *
 * Frozen keeps every decoration visible but inert, per the freeze ACs: "selection handles appear
 * (dimmed/inactive)" and "resize handles appear visually inactive (dimmed)". Only a *locked*
 * selection hides them outright. This applies to single and multi selections alike — batch freeze
 * acts on an existing multi-selection and the selection survives it, so both are reachable.
 */
const FROZEN_DECORATION_OPACITY = 0.45

/** Frame, outline and decoration stroke: locked wins over frozen, frozen over the normal color. */
export function resolveChromeStrokeColor(locked: boolean, frozenOnly: boolean) {
  return locked ? LOCKED_SELECTION_COLOR : frozenOnly ? FROZEN_SELECTION_COLOR : SELECTION_COLOR
}

/** Cursor over the frame interior: the locked/frozen object cursors, otherwise `move`. */
export function resolveChromeBodyCursor(locked: boolean, frozenOnly: boolean) {
  return locked ? LOCKED_OBJECT_CURSOR : frozenOnly ? FROZEN_OBJECT_CURSOR : 'move'
}

/** Opacity of the rotation stem and knob, resize dots and pivot: dimmed while geometry is inactive. */
export function resolveDecorationOpacity(geometryInactive: boolean) {
  return geometryInactive ? FROZEN_DECORATION_OPACITY : 1
}
